import { useBrandLanguagesQuery } from "entities/brands/languages/queries/useBrandLanguagesQuery";
import { BrandLanguage } from "entities/brands/languages/type";
import { useParams } from "react-router-dom";
import TableWithPagination from "shared/components/TableWithPagination";
import { DrawerHookResult } from "shared/hooks/useDrawerState";
import { ExtendedBrandLanguage } from "../../types";
import LanguageDetailsContainer from "./components/LanguageDetails";
import { getBrandLanguagesColumns } from "./helpers";

type LanguagesViewProps = {
  languageDetailsDrawer: DrawerHookResult<ExtendedBrandLanguage>;
};

const LanguagesView = ({ languageDetailsDrawer }: LanguagesViewProps) => {
  const { id } = useParams();
  const brandId = String(id);
  const { data: brandLanguages = [], isLoading: isLoadingLanguages } =
    useBrandLanguagesQuery(brandId);

  const handleOpenLanguageDetailPage = (language: BrandLanguage) => {
    languageDetailsDrawer.openDrawer(language);
  };

  const columns = getBrandLanguagesColumns(handleOpenLanguageDetailPage);

  return (
    <>
      <TableWithPagination<BrandLanguage>
        data={brandLanguages}
        columns={columns}
        loading={isLoadingLanguages}
        emptyStateMessage="No languages found"
        sortingMode="client"
        heightTable={"80vh"}
        hideFooter
        onRowClick={(params) => handleOpenLanguageDetailPage(params.row)}
      />
      <LanguageDetailsContainer
        drawerDetails={languageDetailsDrawer}
        brandId={brandId}
      />
    </>
  );
};

export default LanguagesView;
